import {Component} from 'react';

import queryString from 'query-string';
import CONFIG from '../global/libs/CONFIG.js';
import {getTokenAjax} from '../global/libs/myAjax.js';
import {DEPT_DATA, getDepartmentList} from '../global/libs/departmentUtil.js';
import App from './App.js';
import MultiDepartment from './MultiDepartment.js';
import Unauthorized from './Unauthorized.js';
import {USER_INFO, authenticate, setUserInfoFromQuery} from '../global/libs/authUtil.js';

class AppIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      prepared: false, // flag for if config is updated or not
      initial: true,
      authorized: false,
      authorization_faild: false,
      uid: undefined
    };
  }

  componentDidMount() {
    if (window.location) {
      setUserInfoFromQuery(window.location.search);
    }
    if (CONFIG.REQURE_SOCIAL_LOGIN && !this.state.authorized) {
      this.waitForLogin();
    } else {
      this.setState({authorized: true});
      this.setState({uid: USER_INFO.uid});
    }
  }

  waitForLogin() {
    var self = this;
    var initialized = function () {
      self.setState({initial: false});
    };
    authenticate(initialized)
      .done(() => {
        this.setState({authorized: true});
        console.log('authenticated: ' + USER_INFO);
      })
      .fail(() => {
        this.setState({authorization_faild: true});
      });
  }

  updateMultiDepartment() {
    if (CONFIG.ENABLE_MULTI_DEPT) {
      if (!CONFIG.DISABLE_JWT) {
        getTokenAjax('/get_token/').done(() => {
          if (window.location) {
            getDepartmentList(queryString.parse(window.location.search)).done(() => {
              this.setState({prepared: true});
            });
          }
        });
      } else {
        if (window.location) {
          getDepartmentList(queryString.parse(window.location.search)).done(() => {
            this.setState({prepared: true});
          });
        }
      }
    } else {
      this.setState({prepared: true});
    }
  }

  render() {
    let {prepared} = this.state;
    let {authorized} = this.state;
    let {authorization_faild} = this.state;
    let {initial} = this.state;

    console.log(`authorized:  ${authorized}  initialized:${initial}  prepared:${prepared}`);
    if (authorized && !prepared) {
      this.updateMultiDepartment();
    }

    if (prepared) {
      console.log('prepared');
      // Only render App after data has been prepared,
      // to prevent sudden change of rendered components styles
      if (CONFIG.ENABLE_MULTI_DEPT && DEPT_DATA.length > 1) {
        return <MultiDepartment uid={this.state.uid} />;
      } else {
        return <App uid={this.state.uid} />;
      }
    } else if (authorization_faild) {
      return <Unauthorized />;
    } else if (authorized || initial) {
      return <div />;
    } else {
      if (CONFIG.REQURE_SOCIAL_LOGIN) {
        return <Unauthorized />;
      } else {
        return <div />;
      }
    }
  }
}

export default AppIndex;
